import { generalServiceV1API } from '@/store/api-instance'
import { INotificationFetchRequest, INotificationReadRequest } from '../interfaces'

async function getNotifications (dto: INotificationFetchRequest) {
  let strings = ''
  for (let i = 0; i < dto?.shippingIds?.length; i++) {
    const e = dto.shippingIds[i]
    if (dto.shippingIds[i + 1]) {
      strings = strings + e + ','
    } else {
      strings = strings + e
    }
  }
  const res = await generalServiceV1API.get('notifications/GetNotifications', {
    params: {
      id: dto.id,
      shippingIds: strings
    }
  })
  return res
}

async function updateNotification (dto: INotificationReadRequest) {
  await generalServiceV1API.post(`notifications/ReadNotification?UserId=${dto.userId}&NotificationId=${dto.notificationId}`
  )
}

export {
  getNotifications, updateNotification
}
